var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-categories ff-mont"},_vm._l((_vm.products),function(category,index){return _c('div',{key:index},[_c('div',{staticClass:"tt-categories__tab",class:{ 'tt-categories__tab--active' : _vm.isActiveCategory(index) },on:{"click":function($event){return _vm.setActiveCategory(index)}}},[_vm._v(" "+_vm._s(category.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }